import { createSlice } from '@reduxjs/toolkit';

const loadWishlist = () => {
  try { return JSON.parse(localStorage.getItem('wishlist')) || []; } catch { return []; }
};

const saveWishlist = (items) => {
  try { localStorage.setItem('wishlist', JSON.stringify(items)); } catch {}
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: { items: loadWishlist() },
  reducers: {
    addToWishlist(state, { payload }) {
      if (!state.items.find(i => i.id === payload.id)) {
        state.items.push(payload);
        saveWishlist(state.items);
      }
    },
    removeFromWishlist(state, { payload: id }) {
      state.items = state.items.filter(i => i.id !== id);
      saveWishlist(state.items);
    },
    clearWishlist(state) {
      state.items = [];
      localStorage.removeItem('wishlist');
    },
  },
});

export const { addToWishlist, removeFromWishlist, clearWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
